// extracted by mini-css-extract-plugin
export var wordContainer = "_q9-0";